import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=7e173343&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "@/assets/coupon/style.css?vue&type=style&index=0&id=7e173343&prod&scoped=true&lang=css&external"
import style1 from "@/assets/coupon/footer.css?vue&type=style&index=1&id=7e173343&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e173343",
  null
  
)

export default component.exports